export default __webpack_public_path__ + "static/media/game-welcome-level1.6bd5acc5.png";